export type ScreenSize = "small" | "medium" | "large";
// Be sure to be ordered by size
export const screenSizes: ScreenSize[] = ["small", "medium", "large"];

export function isLarger(aSize: ScreenSize, bSize: ScreenSize, equal = false): boolean {
  if (equal) {
    return screenSizes.indexOf(aSize) >= screenSizes.indexOf(bSize);
  }
  return screenSizes.indexOf(aSize) > screenSizes.indexOf(bSize);
}

export type BreakpointKeys = "medium" | "large";
export const Breakpoints: { [key in BreakpointKeys]: number } = {
  medium: 768,
  large: 1024,
};



// WEBPACK FOOTER //
// ./frontend/src/common/utils/media.ts